import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { PaperCard } from '@iris-platform/iris-react-ui';

const styles = () => ({
  panelContainer: {
    margin: '1em auto',
    width: '80%',
  },
  '@media (maxwidth: 767px)': {
    panelContainer: {
      width: '90%',
    },
  },
  cardHeader: {
    paddingLeft: '20px',
  },
  title: {},
});

const Panel = (props) => {
  const {
    classes,
    header,
    title,
    id,
    avatar,
    children
  } = props;

  return (
    <div className={classes.panelContainer}>
      <PaperCard
        classes={{
          cardHeader: classes.cardHeader,
          title: classes.title,
          card: classes.card,
          cardRoot: classes.cardRoot,
        }}
        id={id}
        title={title}
        avatar={avatar}
      >
        {children}
      </PaperCard>
    </div>
  );
}

export default withStyles(styles)(Panel);
